export const originalPrice = 14900;
